import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ConfigurationItemStatusViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Status())) {
            isComplete = false;
        }
        return isComplete;
    };
    /**
     * Used to eable or disable the delete button for the configurationitemstatus status
     * */
    self.DeleteAllowed = ko.observable();
    self.Status = ko.observable();
    self.Status1 = ko.observable();
    self.Status2 = ko.observable();
    self.Status3 = ko.observable();
    self.Status4 = ko.observable();
    self.Status5 = ko.observable();
    /**
     * Enable/Disable the delete button
     * */
    self.DeleteAllowed.subscribe(function () {

        BaoMenu.permissionEnable({ ActionKey: "ConfigurationItemStatusDelete", Enabled: self.DeleteAllowed(), Context: tabPage.Context() });
        tabPage.IsLoading(false);
    });
    self.Status.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Status1(self.Status());
                break;
            case 2:
                self.Status2(self.Status());
                break;
            case 3:
                self.Status3(self.Status());
                break;
            case 4:
                self.Status4(self.Status());
                break;
            case 5:
                self.Status5(self.Status());
                break;
        }
    });

    self.StatusComputed = ko.computed(function () {
        self.Status1();
        self.Status2();
        self.Status3();
        self.Status4();
        self.Status5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Status(self.Status1());
                break;
            case 2:
                self.Status(self.Status2());
                break;
            case 3:
                self.Status(self.Status3());
                break;
            case 4:
                self.Status(self.Status4());
                break;
            case 5:
                self.Status(self.Status5());
                break;
        }
    });
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.Status1, self.Status2, self.Status3, self.Status4, self.Status5);
        translateDialog.Open().then(function () { });
    };
}
Bao.inherit(ConfigurationItemStatusViewModel, SearchPaging);
ConfigurationItemStatusViewModel.prototype.PrimaryKey = "ConfigurationItemStatusId";
ConfigurationItemStatusViewModel.prototype.RefreshUrl = "ConfigurationItemStatus/Get";
ConfigurationItemStatusViewModel.prototype.SaveUrl = "ConfigurationItemStatus/Save";
ConfigurationItemStatusViewModel.prototype.DeleteUrl = "ConfigurationItemStatus/Delete";
ConfigurationItemStatusViewModel.prototype.IsInUseUrl = "ConfigurationItemStatus/IsInUse";
ConfigurationItemStatusViewModel.prototype.PermissionForward = "ConfigurationItemStatusMoveForwardSearch";
ConfigurationItemStatusViewModel.prototype.PermissionBackward = "ConfigurationItemStatusMoveBackwardSearch";
ConfigurationItemStatusViewModel.prototype.PermissionSave = "ConfigurationItemStatusSave";
ConfigurationItemStatusViewModel.prototype.PermissionRefresh = "ConfigurationItemStatusRefresh";
ConfigurationItemStatusViewModel.prototype.PermissionDelete = "ConfigurationItemStatusDelete";
export default ConfigurationItemStatusViewModel;